import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
} from "react-hook-form";
import { useGetRegions } from "../../../../hooks/react-query/dropdowns/regions.queries";
import { useGetTypeEtablissement } from "../../../../hooks/react-query/dropdowns/type-etablissement.queries";
import {
  EtablissementValidationType,
  Localisation,
} from "../../../../schemas-and-types/etablissement/etablissemen.schema";
import DropdownSection from "../../../global/DropdownSection/DropdownSection";
import InputSection from "../../../global/InputSection/InputSection";
import MapsSearchSection from "../../../global/MapsSearchSection/MapsSearchSection";
import TextAreaSection from "../../../global/TextAreaSection/TextAreaSection";

import { useTranslation } from "react-i18next";
import styles from "./InformationsEtablissement.module.scss";

type Props = {
  register: UseFormRegister<EtablissementValidationType>;
  formErrors: FieldErrors<EtablissementValidationType>;
  setError: UseFormSetError<EtablissementValidationType>;
  clearErrors: UseFormClearErrors<any>;
  setLocalisationOption: React.Dispatch<React.SetStateAction<Localisation>>;
  setRegisterValue: UseFormSetValue<any>; // TODO : Remove 'any' type
  localisationOption: Localisation;
};
function InformationsEtablissement(props: Props) {
  const {
    register,
    formErrors,
    setError,
    clearErrors,
    localisationOption,
    setLocalisationOption,
    setRegisterValue,
  } = props;

  // Fethc the dropdowns options
  const {
    data: typeEtablissementsOptions,
    isLoading: areTypeEtabOptionsLoading,
  } = useGetTypeEtablissement();

  const { data: regionsOptions, isLoading: areRegionOptionsLoading } =
    useGetRegions();
  const { t } = useTranslation()
  return (
    <article
      className={styles.inscriptionEtablissement__main__infoEtablissement}
    >
      <h2 id="anchor-inscription">{t('validation.informationsEtablissement.title')} *</h2>
      <article
        className={
          styles.inscriptionEtablissement__main__infoEtablissement__container
        }
      >
        <section
          className={
            styles.inscriptionEtablissement__main__infoEtablissement__container__left
          }
        >
          {/** FACILITY TYPE DROPDOWN  **/}
          <section id="section1">
            <DropdownSection
              options={typeEtablissementsOptions?.data?.list || []}
              label={t('validation.informationsEtablissement.section1.label')}
              inputId="inscriptionEtab_infoEtab_type"
              placeholder={t('validation.informationsEtablissement.section1.placeholder')}
              name="type"
              register={register}
              formErrors={formErrors}
              areOptionsLoading={areTypeEtabOptionsLoading}
            />
          </section>
          {/** FACILITY NAME AND ADRESSE**/}
          <section id="section2">
            <InputSection
              label={t('validation.informationsEtablissement.section2.input1.label')}
              inputId="inscriptionEtab_infoEtab_nom"
              inputType="text"
              placeholder={t('validation.informationsEtablissement.section2.input1.placeholder')}
              name="name"
              required
              register={register}
              formErrors={formErrors}

            />
            <MapsSearchSection
              label={t('validation.informationsEtablissement.section2.mapSearch.label')}
              inputId="inscriptionEtab_infoEtab_adresse"
              placeholder={t('validation.informationsEtablissement.section2.mapSearch.placeholder')}
              name="address"
              register={register}
              formErrors={formErrors}
              setError={setError}
              clearErrors={clearErrors}
              localisationOption={localisationOption}
              setLocalisationOption={setLocalisationOption}
              setRegisterValue={setRegisterValue}
            />
          </section>
          {/** INFORMATIONS **/}
          <section id="section3">
            <TextAreaSection
              label={t('validation.informationsEtablissement.section3.label')}
              textAreaId="inscriptionEtab_infoEtab_access"
              placeholder={t('validation.informationsEtablissement.section3.placeholder')}
              name="information_access"
              required
              register={register}
              formErrors={formErrors}
            />
          </section>
        </section>
        <section
          className={
            styles.inscriptionEtablissement__main__infoEtablissement__container__separationLine
          }
        ></section>
        {/** DROPDOWN REGION **/}
        <section
          className={
            styles.inscriptionEtablissement__main__infoEtablissement__container__right
          }
          id="section4"
        >
          <DropdownSection
            options={regionsOptions?.data?.list || []}
            label={t('validation.informationsEtablissement.section4.label')}
            inputId="inscriptionEtab_region"
            placeholder={t('validation.informationsEtablissement.section4.placeholder')}
            name="region"
            register={register}
            formErrors={formErrors}
            areOptionsLoading={areRegionOptionsLoading}
          />
          {/** FIRST AND LAST NAME FROM FACILITY DIRECTOR **/}
          <section id="section5">
            <InputSection
              label={t('validation.informationsEtablissement.section5.inputSection1.labelLastName')} //"NOM du ou de la DR"
              inputId="inscriptionEtab_nomDR"
              inputType="text"
              placeholder={t('validation.informationsEtablissement.section5.inputSection1.placeholderLastName')} //"NOM nom du ou de la DR"
              name="nom_dr"
              required
              register={register}
              formErrors={formErrors}

            />
            <InputSection
              label={t('validation.informationsEtablissement.section5.inputSection2.labelFirstName')}// "Prénom du ou de la DR"
              inputId="inscriptionEtab_prenomDR"
              inputType="text"
              placeholder={t('validation.informationsEtablissement.section5.inputSection2.placeholderFirstName')}//"Prénom du ou de la DR"
              name="prenom_dr"
              required
              register={register}
              formErrors={formErrors}

            />
          </section>
        </section>
      </article>
    </article>
  );
}

export default InformationsEtablissement;
